$(document).ready(function(){
    // script to detect the change in range values start
    function checkValue(value){
      if(value == 1){
        $('.template--healthy-coffee-subscription [value="Gift 3 Months of Balance"]').trigger('click');
        $('#months').text('Gift 3 Months of Balance');
      }else if(value == 2){
        $('.template--healthy-coffee-subscription [value="Gift 4 Months of Balance"]').trigger('click');
        $('#months').text('Gift 4 Months of Balance');
      }else if(value == 3){
        $('.template--healthy-coffee-subscription [value="Gift 5 Months of Balance"]').trigger('click');
        $('#months').text('Gift 5 Months of Balance');
      }else if(value == 4){
        $('.template--healthy-coffee-subscription [value="Gift 6 Months of Balance"]').trigger('click');
        $('#months').text('Gift 6 Months of Balance');
      }else if(value == 5){
        $('.template--healthy-coffee-subscription [value="Gift 7 Months of Balance"]').trigger('click');
        $('#months').text('Gift 7 Months of Balance');
      }else if(value == 6){
        $('.template--healthy-coffee-subscription [value="Gift 8 Months of Balance"]').trigger('click');
        $('#months').text('Gift 8 Months of Balance');
      }else if(value == 7){
        $('.template--healthy-coffee-subscription [value="Gift 9 Months of Balance"]').trigger('click');
        $('#months').text('Gift 9 Months of Balance');
      }else if(value == 8){
        $('.template--healthy-coffee-subscription [value="Gift 10 Months of Balance"]').trigger('click');
        $('#months').text('Gift 10 Months of Balance');
      }else if(value == 9){
        $('.template--healthy-coffee-subscription [value="Gift 11 Months of Balance"]').trigger('click');
        $('#months').text('Gift 11 Months of Balance');
      }else if(value == 10){
        $('.template--healthy-coffee-subscription [value="Gift 12 Months of Balance"]').trigger('click');
        $('#months').text('Gift 12 Months of Balance');
      }
    }
    function reverseCheckValue(value){
      if(value == "Gift 3 Months of Balance"){
        $('#myRange').val(1);
        $('#months').text('Gift 3 Months of Balance');
      }else if(value == "Gift 4 Months of Balance"){
        $('#myRange').val(2);
        $('#months').text('Gift 4 Months of Balance');
      }else if(value == "Gift 5 Months of Balance"){
        $('#myRange').val(3);
        $('#months').text('Gift 5 Months of Balance');
      }else if(value == "Gift 6 Months of Balance"){
        $('#myRange').val(4);
        $('#months').text('Gift 6 Months of Balance');
      }else if(value == "Gift 7 Months of Balance"){
        $('#myRange').val(5);
        $('#months').text('Gift 7 Months of Balance');
      }else if(value == "Gift 8 Months of Balance"){
        $('#myRange').val(6);
        $('#months').text('Gift 8 Months of Balance');
      }else if(value == "Gift 9 Months of Balance"){
        $('#myRange').val(7);
        $('#months').text('Gift 9 Months of Balance');
      }else if(value == "Gift 10 Months of Balance"){
        $('#myRange').val(8);
        $('#months').text('Gift 10 Months of Balance');
      }else if(value == "Gift 11 Months of Balance"){
        $('#myRange').val(9);
        $('#months').text('Gift 11 Months of Balance');
      }else if(value == "Gift 12 Months of Balance"){
        $('#myRange').val(10);
        $('#months').text('Gift 12 Months of Balance');
      }
    }
    var initial_value = $(".template--healthy-coffee-subscription input.slider").val();
    checkValue(initial_value);
    $(".template--healthy-coffee-subscription input.slider").change(function(){
      var value = $(this).val();
      checkValue(value);
    });
    // script to detect the change in range values end
    // script to change the variant based on the block change start
    $('.block-swatch-product .block-swatch__radio').change(function(){ 
    	var new_value = [];
    	$('.block-swatch-product .block-swatch__radio').each(function(){ 
    		if($(this).is(':checked')){  
    			new_value.push($(this).attr('value'));		
    		} 
    	}); 
    	$('.block-swatch-product button.combo-box__option-item').each(function(){ 
            if(new_value.indexOf($(this).attr('value')) != -1){
                $(this).trigger('click');
            }
        });
    });
    // script to change the variant based on the block change end
    // script to change range slider if the months are changed from sticky form start
    $('select[aria-label="Months"]').change(function(){
      $('select[aria-label="Months"] option').each(function(){
        if($(this).is(':selected')){
          var value_months = $(this).attr('value');
          reverseCheckValue(value_months);
        }
      });
    });
    // script to change range slider if the months are changed from sticky form end
    // script to split text inside bag size start
    $('.block-swatch-product #select-bag-size + .block-swatch-list label.block-swatch__item').each(function(){
      var text_string = $(this).text();
      var new_array = text_string.split('(');
      var new_html = "<span class = 'bag_weight'>" + new_array[0] + "</span>" + "<span class='cups_size'>(" + new_array[1] + "</span>";
      $(this).html(new_html);
    });
    // script to split text inside bag size end
    // script for semantic date picker start
    $('#example2').calendar({
      type: 'date'
    });
    // script for semantic date picker end
    // script for jquery-ui date picker start
    jQuery(document).ready(function () {
        jQuery('#datepicker').datepicker({
            dateFormat: 'dd/mm/yy',
            startDate: '+1d'
        });
    });
    // script for jquery-ui date picker end
    // script to check if date is selected start
      $('.block-swatch-product product-payment-container').click(function(e){ 
        if($('#datepicker').val() == ''){
          e.preventDefault(); $('#datepicker').addClass('required'); 
        }
      });
      $('.block-swatch-product #datepicker').on('change',function(e){
       $('.block-swatch-product #datepicker').removeClass('required');
      });
    // script to check if date is selected end
    // date picker setting height css script start
    $(document).ready(function(){
      $(".block-swatch-product #datepicker").click(function(){
        var window_width = $(window).innerWidth();
        if(window_width >= 1000 && window_width < 1200 ){
          var height = $('.block-swatch-product .date-container').offset().top - 50;
          $('#ui-datepicker-div').css("top",height + "px");
        }
        if(window_width >= 1200 && window_width < 1500){
          var height = $('.block-swatch-product .date-container').offset().top + 50 ;
          $('#ui-datepicker-div').css("top",height + "px");
        }
        if(window_width >= 1500){
          var height = $('.block-swatch-product .date-container').offset().top - 100;
          $('#ui-datepicker-div').css("top",height + "px");
        }
      });
    });
  // date picker setting height css script end
});
